import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ConcurrentRequestHandlingService } from '@modules/common/services/concurrent-request-handling.service';
import { ApiProxyOptions } from '@modules/common/models/api-proxy-options';
import { UpdatePhoneCallArgs } from './update-phone-call-args.generated';

@Injectable({
    providedIn: 'root'
})
export class UpdatePhoneCallService {
    constructor(private _concurrentRequestHandlingService: ConcurrentRequestHandlingService) { }

    public updatePhoneCall(args: UpdatePhoneCallArgs, options?: ApiProxyOptions): Observable<any> {
        return this._concurrentRequestHandlingService.callApi<any>(
            "UpdatePhoneCallService_updatePhoneCall",
            {
                url: '/Participant/UpdatePhoneCall/UpdatePhoneCall',
                body: typeof args === 'undefined' || args === null ? {} : args,
                sendCredentials: true
            }, options
        );
    }
}
